export const DEVELOPMENT = {
  activeGateway: 'https://api-staging.dochq.co.uk',
  jsonAPI: 'https://api-staging.dochq.co.uk',
  websiteUrl: 'https://staging.dochq.health',
  // careCoreUrl: 'https://testfit2fly.veo365.com/booking_steps/booking_form',
};
